export const actionTypes = {
  TOGGLE_LAYOUT_OPTIONS: 'TOGGLE_LAYOUT_OPTIONS'
}

export function toggleLayout () {
  const { TOGGLE_LAYOUT_OPTIONS } = actionTypes
  return {
    type: TOGGLE_LAYOUT_OPTIONS
  }
}